import Swiper from "../../assets/.npm/node_modules/swiper";
import Navigation from "../../assets/.npm/node_modules/swiper/modules/navigation.min.mjs";

export default () => {
  let swiperPH = new Swiper(".slider-ph", {
    modules: [Navigation],
    slidesPerView: 1, 
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".ph-next",
      prevEl: ".ph-prev",
    }, 
    breakpoints: {
        580: {
            slidesPerView: 2, 
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    },
  });
}
  
